import { I18n } from '@calendly/i18n'
import { uniqBy } from 'lodash-es'
import { nanoid } from 'nanoid'


const formatToSubtitle = (format) => {
  switch (format) {
    case 'string':
      return I18n.t('publisher.event_types.invitee_questions.custom.one_line')
    case 'text':
      return I18n.t('publisher.event_types.invitee_questions.custom.multiple_lines')
    case 'choices_one':
      return I18n.t('publisher.event_types.invitee_questions.custom.radio_buttons')
    case 'choices_many':
      return I18n.t('publisher.event_types.invitee_questions.custom.checkboxes')
    case 'select':
      return I18n.t('publisher.event_types.invitee_questions.custom.select')
    case 'phone_number':
      return I18n.t('publisher.event_types.invitee_questions.custom.phone_number')
    default:
      return null
  }
}

export const getAnswerTypeOptions = () => [
  'string',
  'text',
  'choices_one',
  'choices_many',
  'select',
  'phone_number',
].map((format) => ({
  value: format,
  name: formatToSubtitle(format)
}))

export const reorderQuestions = (questions, items) => {
  const findNewIdx = (question) => items.findIndex((i) => i.id === question.id)
  const newOrder = items.slice().sort((a, b) => findNewIdx(a) - findNewIdx(b))
  const newOrderForShownItems = newOrder.map((q, idx) => ({
    ...q,
    position: idx
  }))

  return uniqBy([...newOrderForShownItems, ...questions], 'id')
}

const hasMultipleLocations = (eventType) => eventType?.location_configurations?.length > 1
const hasAskInvitee = (eventType) => eventType.location_configurations?.some((configuration) => configuration?.kind === 'ask_invitee')
export const showLocationQuestion = (eventType) => {
  const { isSolo, isMultiHost, isCollective, isCollectiveRoundRobin, user_pools: userPools } = eventType
  const allowedEventTypeKinds = (isSolo && !isMultiHost)
    || isCollective
    || (isCollectiveRoundRobin && userPools.some((pool) => pool.pooling_type === 'collective'))

  if (!allowedEventTypeKinds) { return false }

  return hasMultipleLocations(eventType) || hasAskInvitee(eventType)
}

export const determineTextNotifications = (eventType) => {
  const defaultTextNotificationEnabled = eventType.default_notifications.invitee_sms_reminder?.enabled
  const customTextNotificationEnabled = eventType.custom_notifications.invitee_sms_reminder?.enabled

  return defaultTextNotificationEnabled || customTextNotificationEnabled
}

export const determineTextWorkflows = (workflows) => workflows.some(
  (workflow) => workflow.workflow_rule.workflow_actions.some(
    (action) => action.title === I18n.t('publisher.workflows.actions.booking.sms.event_to_invitee.title')))

export const generateBlankQuestion = (position) => ({
  id: `new${nanoid(5)}`,
  name: '',
  format: 'string',
  required: false,
  enabled: true,
  answerChoices: null,
  includeOther: false,
  isCreationFlow: true,
  position,
})

export const questionsToCards = (questions) => questions.map(({ name, format }) => ({
  title: name,
  subtitle: formatToSubtitle(format)
}))
